import {
  VStack,
  colors,
  LargeButton,
  LARGEL_BUTTON_TYPE,
  NextLink,
  responsive,
  ColorIcon,
  HStack,
  customEvent,
} from "goi_common";
import { Box } from "@chakra-ui/react";
import { MAX_WIDTH } from "@/constants/components";

import styled from "@emotion/styled";
import LazyLoad from "goi_common/src/components/LazyLoad";
import { useRouter } from "next/router";

export default function ReviewSection() {
  const router = useRouter();
  return (
    <VStack
      width="100%"
      alignItems="center"
      background={colors.warmGray100}
      css={responsive({
        padding: { base: "48px 12px 40px", lg: "100px 0 40px" },
      })}
    >
      <VStack
        maxWidth={`${MAX_WIDTH}px`}
        width="100%"
        css={responsive({
          padding: { base: "0 24px 16px", lg: "0 24px 64px" },
        })}
      >
        <Box className="gray900 head_24_eb lg_head_42_b" textAlign="center">
          <b className="orange650">실제 고이에서 장례를 치르신</b> <br />
          박승호님의 후기입니다.
        </Box>
      </VStack>

      <VStack
        background={colors.white}
        css={responsive({
          padding: { base: "24px 0", lg: "40px 100px" },
          borderRadius: "16px",
          boxShadow: "0px 0px 16px rgba(0, 0, 0, 0.08)",
          width: { base: "100%", lg: "1100px" },
        })}
        alignItems="center"
        gap="30px"
      >
        <VStack width="100%" alignItems="center">
          <LazyLoad width="100%" height="100%" top={-400}>
            <IframeWrapper>
              <YoutubeIframe
                src={`https://www.youtube.com/embed/BgaaS2DSEcA/?autoplay=1&mute=1&controls=1&loop=1&start=226&cc_load_policy=0`}
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              />
            </IframeWrapper>
          </LazyLoad>
        </VStack>
        <HStack gap="6px">
          <ColorIcon
            name="icon-quote-mono"
            size={20}
            color={colors.gray400}
            css={{ transform: "translateX(0px)" }}
          />
          <Box
            className="gray900 head_24_eb lg_head_32_b"
            textAlign="center"
            margin="0 6px 0"
          >
            내 가족이 돌아가신 것처럼 <br />
            정말 해주시더라고요
          </Box>
          <ColorIcon
            name="icon-quote-mono"
            size={20}
            color={colors.gray400}
            css={{ transform: "rotate(180deg) translateX(0px)" }}
          />
        </HStack>
        <p
          className="gray600"
          css={responsive({
            textAlign: "center",
            fontSize: { base: "18px", lg: "21px" },
            padding: { base: "0 12px", lg: "0" },
          })}
        >
          제가 장례식장에 직접 전화를 걸어봤어요.
          <br />
          동네 펜션 잡듯이 “뭐 하루밤 잘거에요?” <br />
          그러니까 기분이 나쁘더라고요.
          <br />
          <br />
          <b className="gray900">
            고이에서는 같이 공감을 해주시면서 <br />
            위로를 먼저 해주시더라고요
          </b>
        </p>
      </VStack>

      <Box
        className="gray900 head_24_eb lg_head_42_b"
        textAlign="center"
        padding="38px 0 2px"
      >
        100원 상조 실제 이용 후기
      </Box>

      <VStack
        background={colors.white}
        css={responsive({
          padding: { base: "18px 20px 26px", lg: "20px 100px 30px" },
          marginTop: "20px",
          borderRadius: "16px",
          boxShadow: "0px 0px 16px rgba(0, 0, 0, 0.08)",
          width: { base: "100%", lg: "1100px" },
        })}
        gap="10px"
      >
        <VStack gap={0}>
          <HStack justifyContent="space-between" alignItems="center">
            <div className="body3_m" style={{ color: colors.gray400 }}>
              한OO 님의 후기 | 2025년 3월 10일
            </div>
            <HStack
              onClick={() => {
                customEvent({
                  newGtm: {
                    path: "home",
                    trigger_and_target: "card-uv_review_detail",
                  },
                });
                router.push(`https://www.goifuneral.co.kr/review/774/`);
              }}
              className="gray900 caption_12_sb"
              alignItems="center"
              gap={4}
            >
              더보기
              <ColorIcon
                name="icon-arrow-right-circle-mono"
                color={colors.warmGray700}
                size={16}
              />
            </HStack>
          </HStack>
          <HStack gap={6} className="subtitle_16_b" alignItems="center">
            <HStack gap={1}>
              {Array(5)
                .fill(0)
                .map((item, index) => (
                  <ColorIcon
                    key={index}
                    name="rating_star"
                    color="#F18334"
                    size={14}
                  />
                ))}
            </HStack>
            <Box className="gray900">5</Box>
          </HStack>
        </VStack>
        <Box className="gray900 subtitle_18_sb">
          100원 고이상조 가볍게 가입해두었는데 정말 유용했고 많은 도움
          받았습니다.
        </Box>
        <Box className="gray900 subtitle_16_sb">
          불필요한 절차들이나 보다 합리적으로 장례 치를 수 있도록 많이
          안내해주셨고 불편하실수 있는 부분도 내색없이 처리해 주셨습니다.
        </Box>
      </VStack>

      <VStack
        background={colors.white}
        css={responsive({
          padding: { base: "18px 20px 26px", lg: "20px 100px 30px" },
          marginTop: "20px",
          borderRadius: "16px",
          boxShadow: "0px 0px 16px rgba(0, 0, 0, 0.08)",
          width: { base: "100%", lg: "1100px" },
        })}
        gap="10px"
      >
        <VStack gap={0}>
          <HStack justifyContent="space-between" alignItems="center">
            <div className="body3_m" style={{ color: colors.gray400 }}>
              김OO 님의 후기 | 2025년 1월 27일
            </div>
            <HStack
              onClick={() => {
                customEvent({
                  newGtm: {
                    path: "home",
                    trigger_and_target: "card-uv_review_detail",
                  },
                });
                router.push(`https://www.goifuneral.co.kr/review/689/`);
              }}
              className="gray900 caption_12_sb"
              alignItems="center"
              gap={4}
            >
              더보기
              <ColorIcon
                name="icon-arrow-right-circle-mono"
                color={colors.warmGray700}
                size={16}
              />
            </HStack>
          </HStack>
          <HStack gap={6} className="subtitle_16_b" alignItems="center">
            <HStack gap={1}>
              {Array(5)
                .fill(0)
                .map((item, index) => (
                  <ColorIcon
                    key={index}
                    name="rating_star"
                    color="#F18334"
                    size={14}
                  />
                ))}
            </HStack>
            <Box className="gray900">5</Box>
          </HStack>
        </VStack>
        <Box className="gray900 subtitle_18_sb">
          오빠가 여행가는 먼 길 헤매지 않도록 경황없을 부모님대신 제가 알아보고
          가입했어요.
        </Box>
        <Box className="gray900 subtitle_16_sb">
          상조라는게 사실 필요할까 싶었는데 하다보니 꼭 있어야 하는구나.. 잘
          준비했다 싶었던 순간들이 정말 많습니다. 이 자리를 빌어 다시한번
          감사인사 드립니다.
        </Box>
      </VStack>
      <VStack
        background={colors.white}
        css={responsive({
          padding: { base: "18px 20px 26px", lg: "20px 100px 30px" },
          marginTop: "20px",
          borderRadius: "16px",
          boxShadow: "0px 0px 16px rgba(0, 0, 0, 0.08)",
          width: { base: "100%", lg: "1100px" },
        })}
        gap="10px"
      >
        <VStack gap={0}>
          <HStack justifyContent="space-between" alignItems="center">
            <div className="body3_m" style={{ color: colors.gray400 }}>
              고OO 님의 후기 | 2025년 3월 19일
            </div>

            <HStack
              onClick={() => {
                customEvent({
                  newGtm: {
                    path: "home",
                    trigger_and_target: "card-uv_review_detail",
                  },
                });
                router.push(`https://www.goifuneral.co.kr/review/782/`);
              }}
              className="gray900 caption_12_sb"
              alignItems="center"
              gap={4}
            >
              더보기
              <ColorIcon
                name="icon-arrow-right-circle-mono"
                color={colors.warmGray700}
                size={16}
              />
            </HStack>
          </HStack>
          <HStack gap={6} className="subtitle_16_b" alignItems="center">
            <HStack gap={1}>
              {Array(5)
                .fill(0)
                .map((item, index) => (
                  <ColorIcon
                    key={index}
                    name="rating_star"
                    color="#F18334"
                    size={14}
                  />
                ))}
            </HStack>
            <Box className="gray900">5</Box>
          </HStack>
        </VStack>
        <Box className="gray900 subtitle_18_sb">
          엄마가 준비하신 상조도 있었지만 후기가 좋아서 고이로 선택했는데 정말
          잘 선택 한 거 같습니다
        </Box>
        <Box className="gray900 subtitle_16_sb">
          출산 한달만에 돌아가셔서 몸조리도 제대로 못하고 정신없는데다 컨디션도
          안 좋아서 표정관리가 안됐는데 계속 신경써주시고 저한테 맞춰
          설명해주셔서 이해도 잘 됐습니다
          <br />
          집안 어르신분들도 하나같이 모두 칭찬하셨어요
        </Box>
      </VStack>

      <NextLink
        href="https://www.goifuneral.co.kr/review/"
        css={responsive({
          width: { base: "100%", lg: "400px" },
          padding: "20px 24px 0",
        })}
        event={{
          newGtm: {
            path: "home",
            trigger_and_target: "CTA-uv_review",
          },
        }}
      >
        <LargeButton
          className="subtitle_18_b"
          buttonType={LARGEL_BUTTON_TYPE.ORANGE}
          height={52}
        >
          더 많은 실제 후기 확인하기
        </LargeButton>
      </NextLink>
    </VStack>
  );
}

const IframeWrapper = styled.div`
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;
`;
const YoutubeIframe = styled.iframe`
  position: absolute;
  width: 100%;
  height: 100%;
`;
